interface EnvironmentConfig {
  aws: {
    region: string;
    cognito: {
      domain: string;
      clientId: string;
    };
  };
  api: {
    quizGenerator: string;
    quizStorage: string;
    bff: string;
    stripe: string;
    avatar: string;
  };
  stripe: {
    priceMonthly: string;
    priceYearly: string;
  };
  websocket: {
    proxy: string;
  };
  playerUrl: string;
}

const getEnvVar = (key: string, defaultValue: string = ''): string => {
  const value = process.env[key];
  if (!value && !defaultValue) {
    console.warn(`Missing environment variable: ${key}`);
  }
  return value || defaultValue;
};

export const environment: EnvironmentConfig = {
  aws: {
    region: getEnvVar('REACT_APP_AWS_REGION', 'us-east-2'),
    cognito: {
      domain: getEnvVar('REACT_APP_COGNITO_DOMAIN', 'quizriot-prod-admin.auth.us-east-2.amazoncognito.com'),
      clientId: getEnvVar('REACT_APP_COGNITO_CLIENT_ID', '4ful06vkac5jl2khdr8bjlndsj'),
    },
  },
  api: {
    quizGenerator: getEnvVar('REACT_APP_QUIZ_GENERATOR_API', 'https://rrbxmtlnamifnhvqkfr4eq4rim0srmtz.lambda-url.us-east-2.on.aws'),
    quizStorage: getEnvVar('REACT_APP_QUIZ_STORAGE_API', 'https://2cuhfuxm7dk6degbu7ykrzkpyi0hbngd.lambda-url.us-east-2.on.aws'),
    bff: getEnvVar('REACT_APP_BFF_API', 'https://6g3gjo63d7gkpu5wv3ggrv7en40jlvlj.lambda-url.us-east-2.on.aws'),
    stripe: getEnvVar('REACT_APP_STRIPE_API', 'https://5lap5ejybexbiryg5rdardqht40dpxwb.lambda-url.us-east-2.on.aws'),
    avatar: getEnvVar('REACT_APP_AVATAR_API', 'https://ifiqy2f2gp3z4pfpjoa5kc74se0mdpnv.lambda-url.us-east-2.on.aws'),
  },
  stripe: {
    // Production defaults (live prices)
    // For local development with test prices, override in .env.local
    priceMonthly: getEnvVar('REACT_APP_STRIPE_PRICE_MONTHLY', 'price_1SEeQq7m4yNsndPGnhAlWajj'),
    priceYearly: getEnvVar('REACT_APP_STRIPE_PRICE_YEARLY', 'price_1SEeUL7m4yNsndPGxyU8oS5h'),
  },
  websocket: {
    proxy: getEnvVar('REACT_APP_WEBSOCKET_PROXY', 'wss://wsproxy.quizriot.live'),
  },
  playerUrl: getEnvVar('REACT_APP_PLAYER_URL', 'https://play.quizriot.live'),
};

export default environment;